<tt-page>
    <tt-page-heading ttModel="p2_m_orderheadexternalcost" ttTranslate></tt-page-heading>
    <tt-grid class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
